// eslint-disable-next-line @typescript-eslint/ban-types
import axios from "axios"

let configureStore: Function
if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    configureStore = require("./configureStore.dev").configureStore
} else {
    axios.defaults.baseURL = window.location.origin.toString()
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    configureStore = require("./configureStore.prod").configureStore
}
const store = configureStore()
export default store
